import React from 'react';
import { TableList } from 'seagull';
import styles from "./BillTableItem.module.scss";
export default function BillTableItem(props) {
  const {
    columnDefs,
    headerItems,
    rowItems,
    newUI,
    footer,
    headerTestId,
    actionColumn
  } = props;
  return /*#__PURE__*/React.createElement(TableList.Provider, {
    columnDefs: columnDefs,
    variant: newUI ? 'minimal' : undefined,
    hasActionColumn: true
  }, /*#__PURE__*/React.createElement("div", {
    className: newUI ? styles.root : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: newUI ? styles.innerContainer : undefined
  }, /*#__PURE__*/React.createElement(TableList.Header, {
    className: styles.tableHeader,
    items: headerItems,
    "data-testid": headerTestId,
    bgColor: "darkGray"
  }), /*#__PURE__*/React.createElement(TableList.Row, {
    disableShadow: true,
    disableMarginBottom: newUI,
    items: rowItems,
    actionColumn: actionColumn
  }), footer)));
}